export default __webpack_public_path__ + "static/media/Knet.7f1d9bcf.png";